import script from "./objectHeaderNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./objectHeaderNavigation.vue?vue&type=script&setup=true&lang=js"

import "./objectHeaderNavigation.vue?vue&type=style&index=0&id=c833665c&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c833665c"]])

export default __exports__